export default __webpack_public_path__ + "static/media/icUnlock.3d33d1b9.svg";